import React from "react"

import RichText from "../RichText"

// Salesforce Forms
//=======================================================
import ProductQuality from "./FormTypes/ProductQuality"
import ProductQualityNZ from "./FormTypes/ProductQualityNZ"
import GeneralEnquiry from "./FormTypes/GeneralEnquiry"
import GeneralEnquiryNZ from "./FormTypes/GeneralEnquiryNZ"
import AskADietitian from "./FormTypes/AskADietitian"
import AskADietitianNZ from "./FormTypes/AskADietitianNZ"
import CommunityCareNZ from "./FormTypes/CommunityCareNZ"
import Subscribe from "./FormTypes/Subscribe"
import SubscribeNZ from "./FormTypes/SubscribeNZ"

// Typeform Forms
//=======================================================
// import TFGeneralEnquiry from "./FormTypes/TypeForm/TFGeneralEnquiry"
// import TFGeneralEnquiryNZ from "./FormTypes/TypeForm/TFGeneralEnquiryNZ"
// import TFAskDietitian from "./FormTypes/TypeForm/TFAskDietitian"
// import TFAskDietitianNZ from "./FormTypes/TypeForm/TFAskDietitianNZ"
// import TFProductQuality from "./FormTypes/TypeForm/TFProductQuality"
// import TFProductQualityNZ from "./FormTypes/TypeForm/TFProductQualityNZ"
// import TFCommunityCareNZ from "./FormTypes/TypeForm/TFCommunityCareNZ"

import { FormGroupModel } from "../../models/modules"

interface Props extends FormGroupModel {
  workingHandler?: Function
  pageContext: any
}

const defaultProps = {}

export const Form: React.FC<Props> = props => {
  return (
    <>
      {props.content_before && (
        <section>
          <RichText
            content={props.content_before}
            pageContext={props.pageContext}
          />
        </section>
      )}

      {props.form_type === "General enquiry" && (
        <GeneralEnquiry
          workingHandler={props.workingHandler}
          pageContext={props.pageContext}
        />
      )}
      {props.form_type === "General enquiry NZ" && (
        <GeneralEnquiryNZ
          workingHandler={props.workingHandler}
          pageContext={props.pageContext}
        />
      )}

      {props.form_type === "Product quality" && (
        <ProductQuality
          workingHandler={props.workingHandler}
          pageContext={props.pageContext}
        />
      )}
      {props.form_type === "Product quality NZ" && (
        <ProductQualityNZ
          workingHandler={props.workingHandler}
          pageContext={props.pageContext}
        />
      )}

      {props.form_type === "Ask a dietitian" && (
        <AskADietitian
          workingHandler={props.workingHandler}
          pageContext={props.pageContext}
        />
      )}
      {props.form_type === "Ask a dietitian NZ" && (
        <AskADietitianNZ
          workingHandler={props.workingHandler}
          pageContext={props.pageContext}
        />
      )}

      {props.form_type === "Subscribe" && (
        <Subscribe pageContext={props.pageContext} />
      )}
      
      {props.form_type === "SubscribeNZ" && (
        <SubscribeNZ pageContext={props.pageContext} />
      )}

      {props.form_type === "Community Care NZ" && (
        <CommunityCareNZ
          workingHandler={props.workingHandler}
          pageContext={props.pageContext}
        />
      )}

      {props.content_after && (
        <section>
          <RichText
            content={props.content_after}
            pageContext={props.pageContext}
          />
        </section>
      )}
    </>
  )
}

Form.defaultProps = defaultProps

export default Form
